// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"4c4527fb","208":"87722b7d","236":"18fd18a4","353":"c1f2a6b5","512":"24eb8011","549":"bd441398","813":"8a43830d"}[chunkId] + ".chunk.js";
};